"use client";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Rate, Input, notification, Button, Spin } from "antd";
import { MdError } from "react-icons/md";
import reviewAPI from "@/services/review_api";
import { CiLocationArrow1 } from "react-icons/ci";
import { AppDispatch, RootState } from "@/redux/store";
import { useAuth } from "@/hooks";
import { showModalForm } from "@/redux/reducers/user.reducer";
import { IoIosSend } from "react-icons/io";
import { definitions } from "@/services/metruyenvl";
import { statAPI } from "@/services/stat_api";
import { ResponseTypes } from "@/types/constants";
import { createReview } from "@/redux/reducers/book.reducer";

interface IReview {
    book_id?: string;
    content?: string;
    score?: number;
}

const { TextArea } = Input;

function InputReview({ book }: { book: definitions["do.BookDO"] }) {
    const { isAuth } = useAuth();
    const dispatch = useDispatch<AppDispatch>();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [notiService, contextHolder] = notification.useNotification();

    const [reviewCover, setReviewCover] = useState<IReview>({
        content: "",
        score: 5,
        book_id: book?.id,
    });

    const [reviewStats, setReviewStats] = useState<definitions["do.StatsDO"]>();

    const getReviewStats = async () => {
        try {
            const res: ResponseTypes = await statAPI.getStat("review", book.id as string);
            setReviewStats(res.data);
        } catch (error) {
            console.log(error);
        }
    };

    const key = "updatable";
    const openNotification = () => {
        notiService.open({
            key,
            message: (
                <div className="flex items-center gap-x-2">
                    Lỗi <MdError color={"red"} size={20} />
                </div>
            ),
            description: <div>Bạn đã đánh giá tại truyện đọc này rồi!</div>,
        });
    };

    const postReview = async () => {
        setIsLoading(true);

        try {
            if (!reviewCover || !reviewCover.content || !reviewCover.score) {
                notiService.open({
                    key,
                    message: (
                        <div className="flex items-center gap-x-2">
                            Lỗi <MdError color={"red"} size={20} />
                        </div>
                    ),
                    description: <div>Không thể gửi đánh giá trống</div>,
                });
            }

            if (isAuth) {
                dispatch(createReview({ bookID: book.id as string, content: reviewCover.content as string, score: reviewCover.score as number }));

                setReviewCover({ ...reviewCover, score: 5, content: "" });
            } else {
                setReviewCover({ ...reviewCover, score: 5, content: "" });
                dispatch(showModalForm(true));
            }
        } catch (error) {
            console.log("Input Review error: ", error);
            openNotification();
            setReviewCover({ ...reviewCover, score: 5, content: "" });
        }

        setIsLoading(false);
    };

    return (
        <Spin spinning={isLoading}>
            <div className="w-full font-semibold text-base p-4" style={{ color: "rgb(217, 119, 6)", backgroundColor: "#f7f5f0" }}>
                {contextHolder}
                <div className="flex items-center gap-x-4 mb-2">
                    <div className="">Đánh giá</div>
                    <Rate
                        allowHalf
                        value={reviewCover.score}
                        onChange={(value: number) => {
                            setReviewCover({ ...reviewCover, score: value });
                        }}
                    />
                    <div className="font-semibold ml-8">{reviewCover.score}</div>
                </div>

                <div className="relative">
                    <TextArea
                        placeholder="Nhập đánh giá của bạn..."
                        rows={4}
                        className="w-full h-min pr-20"
                        style={{ minHeight: "90px" }}
                        value={reviewCover.content}
                        onChange={(e) => {
                            setReviewCover({ ...reviewCover, content: e.target.value });
                        }}
                    >
                        {" "}
                    </TextArea>
                    <button onClick={postReview} className="absolute z-10 bottom-2 right-3 bg-orange-800 p-3 text-3xl rounded-full">
                        <IoIosSend color="white" className="md:w-6 md:h-6 h-5 w-5" />
                    </button>
                </div>
            </div>
        </Spin>
    );
}

export default InputReview;
